
import { toTitleCase } from "../../utilities/functions";
import { AllCommunityModule, ModuleRegistry, themeAlpine } from 'ag-grid-community'; 
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import Select from 'react-select';
import styles from './AGTable.module.css';
import { useState } from "react";
import { Button } from "react-bootstrap";
import DownloadIcon from '@mui/icons-material/Download';

ModuleRegistry.registerModules([AllCommunityModule]);

const AGTable = (props) => {
    // const gridRef = useRef();
    const gridRef = props?.gridRef;
    const data = props.data;
    const setUpdatedRow = props.setUpdatedRow;
    let rowHeight = props?.rowHeight;
    const showSelect = props?.showSelect;
    const onGridReady = props?.onGridReady;
    const setSelectedFn = props?.setSelected;
    const getRowId = props?.getRowId;
    const keepRawHeaders = props.keepRawHeaders;
    const customFlex = props.customFlex;
    const key = props.id;
    if (!props?.rowHeight){
        rowHeight = 40;
    }
    const maxRows = 15;
    const gridHeight = Math.min(data.length, maxRows) * rowHeight + 87; // extra for headers
    const [selectedColumns, setSelectedColumns] = useState(
        [...new Set(data.flatMap(obj => Object.keys(obj)))].filter(key => !props?.columnsToHide?.includes(key))
        .map((key) => {
            return {
                value: key,
                label: keepRawHeaders ? key : toTitleCase(key.replace(/_/g, " "))
            }
        })
    );
    const allKeys = [...new Set(data.flatMap(obj => Object.keys(obj)))].map((row, index) => {
        let obj = {
            "field": row,
            "flex": customFlex?.find(col => col.col === row) ? customFlex?.find(col => col.col === row)?.flex : 1,
            "headerName": keepRawHeaders ? row : toTitleCase(row.replace(/_/g, " ")),
            "hide": !selectedColumns?.some(key => row === key?.value),
            "editable": props?.editableFields?.includes(row) ? true : false,
            filterParams: {
                maxNumConditions: 5
            },
            cellRenderer: (params) => {
                const value = params.value;
                const isLink = typeof value === 'string' && value.startsWith('https://');
          
                return isLink ? (
                  <a href={value} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2' }}>
                    {value}
                  </a>
                ) : (
                  <span>{value}</span>
                );
            },
            // cellClassRules: props?.conditionalRules?.map((element) => {
            //     if (element?.column?.includes(row)){
            //         return element?.rules;
            //     }
            //     return null;
            // })[0],
            cellClassRules: (() => {
                // 1. Find the relevant rule set for this column
                const activeElement = props?.conditionalRules?.find(element => 
                    element?.column?.includes(row)
                );

                if (!activeElement || !activeElement.rules) return {};

                // 2. Map the "clean" keys to the "mangled" CSS Module keys
                const mappedRules = {};
                Object.entries(activeElement.rules).forEach(([className, condition]) => {
                    // Look up the mangled name in your styles object
                    const scopedName = styles[className] || className; 
                    mappedRules[scopedName] = condition;
                });

                return mappedRules;
            })()
            
        };
        const editableSelect = props?.editableSelectConfig?.find(col => col.columnName === row);
        if (editableSelect){
            obj.cellEditor = "agSelectCellEditor";
            obj.cellEditorParams = {
                values: editableSelect?.values,
            }
        }
        return obj;
    });

    const onExportClick = () => {
        gridRef.current.api.exportDataAsCsv({
            fileName: props?.fileName
        });
    };

    const onCellValueChanged = async(event) => {
        if (setUpdatedRow){
            setUpdatedRow(event?.data);
        }
    };

    const onSelectionChanged = (event) => {
        setSelectedFn([...event.selectedNodes.map(node => node?.data)]);
    }

    return (
        <div>
            {!props?.hideFilters && <div>
                <p>Hide/Show Columns</p>
                <div className={styles.Filters}>
                    <div style={{ flex: '1' }}>
                        <Select 
                            options={allKeys.map((key) => {
                                return {
                                    value: key?.field,
                                    label: key?.headerName
                                }
                            })}
                            isMulti
                            menuPortalTarget={document.body} // render dropdown at body level
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            value={selectedColumns}
                            onChange={setSelectedColumns}
                        />
                    </div>
                    <Button variant="success" onClick={onExportClick}><DownloadIcon/></Button>
                </div>
            </div>}
            <br/>
            <div style={{ height: `${gridHeight}px`}}>
                <div className="ag-theme-alpine" style={{ height: '100%'}}>
                    <AgGridReact
                        // key={JSON.stringify(data)}
                        key={key}
                        ref={gridRef}
                        rowData={data}
                        columnDefs={allKeys}
                        theme={themeAlpine}
                        rowHeight={rowHeight}
                        // rowHeight={40}
                        headerHeight={40}
                        rowSelection={showSelect && {mode: 'multiRow', selectAll: 'filtered'}}
                        pagination={true}
                        defaultColDef={{
                            flex: 1,
                            filter: true,
                            sortable: true,
                        }}
                        onCellValueChanged={onCellValueChanged}
                        onGridReady={onGridReady}
                        onSelectionChanged={setSelectedFn && onSelectionChanged}
                        getRowId={getRowId}
                    />
                </div>
            </div>
            {/* <br/> */}
      </div>
    );
};

export default AGTable;